'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logout = require('./logout.html');

var _logout2 = _interopRequireDefault(_logout);

var _logout3 = require('./logout.controller');

var _logout4 = _interopRequireDefault(_logout3);

require('./logout.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoutComponent = {
  restrict: 'E',
  bindings: {},
  template: _logout2.default,
  controller: _logout4.default,
  controllerAs: 'vm'
};

exports.default = logoutComponent;


// WEBPACK FOOTER //
// ./client/app/components/logout/logout.component.js